import { render } from "./AssetsChangeForm.vue?vue&type=template&id=c610091a"
import script from "./AssetsChangeForm.vue?vue&type=script&lang=js"
export * from "./AssetsChangeForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__